<!-- eslint-disable vue/max-attributes-per-line -->
<template>
  <div class="list-wrap">
    <!-- 时间容器 -->
    <div class="header-wrap">
      <div class="date-wrap">
        <div class="desc">时间</div>
        <div class="date-selector">
          <div class="date-field" @click="changeDate(1)">
            {{ startDate | currenDate }}
          </div>
          <div class="range">—</div>
          <div class="date-field" @click="changeDate(2)">
            {{ endDate | currenDate }}
          </div>
          <div class="select-box">
            <div
              :class="[item.value === dayValue ? 'active item' : 'item']"
              v-for="(item, index) in dayNum"
              :key="index"
              @click="changeDay(item)"
            >
              {{ item.desc }}
            </div>
          </div>
        </div>
      </div>
      <!--排序-->
      <div class="sort-wrap">
        <div class="desc">排序</div>
        <div class="sort-box">
          <div
            :class="[item.value === pageInfo.sortType ? 'active item' : 'item']"
            :key="index"
            v-for="(item, index) in sortData"
            @click="changeSort(item)"
          >
            {{ item.title }}
          </div>
        </div>
      </div>
    </div>
    <div class="data-wrap" v-if="tableData.length">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list v-model="loading" :finished="finished" @load="onLoad">
          <div class="item" v-for="(item, index) in tableData" :key="index">
            <div class="top" @click="navToDetail(item)">
              <div class="img-wrap">
                <img class="map-img" :src="item.url" v-if="item.url" />
                <img class="map-img" src="@/assets/images/img_map_no_url.png" v-else />
                <img
                  v-if="item.ctype === 1"
                  class="corner"
                  src="@/assets/images/corner_works_map.png"
                  alt="corner"
                />
                <img
                  v-if="item.ctype === 2"
                  class="corner"
                  src="@/assets/images/corner_works_game.png"
                  alt="corner"
                />
              </div>
              <div class="right">
                <div class="title">
                  {{ item.name }}
                </div>
                <div class="label">
                  <div class="label1" v-if="item.label">
                    {{ item.label | _regroupMapType }}
                  </div>
                  <div
                    class="label2 success"
                    v-if="item.open_svr == 10 || item.open_svr == 13"
                  >
                    {{ item.open_svr | regroupMapStatus }}
                  </div>
                  <div
                    class="label2 fail"
                    v-else-if="item.open_svr == 4 || item.open_svr == 14"
                  >
                    {{ item.open_svr | regroupMapStatus }}
                  </div>
                  <div class="label2" v-else>
                    {{ item.open_svr | regroupMapStatus }}
                  </div>
                </div>
                <div class="time">{{ item.upload_time }}</div>
              </div>
            </div>
            <div class="bottom">
              <div class="top-box">
                <div class="value">迷你豆 {{ item.minibean | transWan }}</div>
                <div class="value-custom">
                  贡献点 {{ item.contribution | transWan }}
                </div>
                <div class="value">迷你点 {{ item.minipoint | transWan }}</div>
              </div>
              <div class="bottom-box">
                <div class="value">广告 {{ item.ad_income | transWan }}</div>
                <div class="value-custom value-custom-w">
                  <!-- 激励金 {{ item.other | transWan }} -->
                  <van-collapse v-model="activeNames" accordion :border="false">
                    <van-collapse-item
                      :title="`激励金 ${sumNumber(item)}`"
                      name="1"
                      :border="false"
                    >
                      <p>星启激励A收入: {{ item.xq4_time || 0 }}</p>
                      <p>星启激励B收入: {{ item.xq4_shop || 0 }}</p>
                      <p>星启3.0-计划收入: {{ item.xq3 || 0 }}</p>
                    </van-collapse-item>
                  </van-collapse>
                </div>
                <!-- <div class="value">星启4.0时长奖金: {{ item.xq4_time }}</div> -->
              </div>
            </div>
          </div>
          <div class="complete-tip" v-if="tableData.length >= pageInfo.total">
            到底啦！
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
    <NoData v-else></NoData>
    <!-- 日期选择器开始时间-->
    <van-popup v-model="showStart" position="bottom">
      <van-datetime-picker
        v-model="startDate"
        type="date"
        :max-date="maxStartDate"
        @confirm="updateStartDate"
      >
      </van-datetime-picker>
    </van-popup>
    <van-popup v-model="showEnd" position="bottom">
      <van-datetime-picker
        v-model="endDate"
        type="date"
        :max-date="maxEndDate"
        @confirm="updateEndDate"
      >
      </van-datetime-picker>
    </van-popup>
    <!-- </div>   -->
  </div>
</template>
<script>
const ONE_WEEK_TIME = 1000 * 60 * 60 * 24 * 7;
const ONE_DAY_TIME = 24 * 60 * 60 * 1000;
const ONE_DAY = 24 * 60 * 60 * 1000;
import { getIncomeWorkList } from '@/api/income';
import { regroupMapType } from '@/utils/index.js';
// import { Collapse, CollapseItem } from 'vant';
import NoData from '@/components/NoData.vue';
export default {
  components: {
    NoData,
  },
  data() {
    return {
      isLoading: false,
      showStart: false,
      loading: false,
      finished: false,
      startValue: 0,
      endValue: 0,
      refreshing: false, //下拉刷新
      showEnd: false,
      minStartDate: '',
      minEndDate: '',
      maxEndDate: new Date(),
      maxStartDate: new Date(),
      searchParams: {
        sort_type: 0,
        page: 1,
        page_size: 10,
      },
      tableData: [],
      dayNum: [
        {
          desc: '7天',
          value: 7,
        },
        {
          desc: '30天',
          value: 30,
        },
        {
          desc: '90天',
          value: 90,
        },
      ],
      sortData: [
        {
          title: '发布时间',
          value: 4,
        },
        {
          title: '迷你豆',
          value: 6,
        },
        {
          title: '迷你点',
          value: 7,
        },
        {
          title: '贡献点',
          value: 8,
        },
        {
          title: '广告',
          value: 9,
        },
      ],
      activeNames: ['1'],
      range: 4,
      pageInfo: {
        page: 1,
        pageSize: 10,
        total: 0,
        sortType: 4,
      },
      singelData: {},
      startDate: '',
      endDate: '',
      dayValue: 7,
      mapColumns: [
        { prop: 'name', label: '地图名称' },
        { prop: 'today_download', label: '今日下载(预估)' },
        { prop: 'yesterday_download', label: '昨日下载' },
        { prop: 'total_download', label: '总下载' },
        { prop: 'yesterday_ad_count', label: '昨日广告展示' },
        { prop: 'ad_count', label: '总广告展示' },
        { prop: 'time', label: '上传日期', width: 100 },
      ],
      mapList: [],
      dataTotal: 0,
    };
  },
  created() {
    //初始化时间
    const currTime = new Date(new Date(new Date()).toDateString()).getTime();
    this.startDate = new Date(currTime - ONE_WEEK_TIME);
    this.endDate = new Date(currTime - ONE_DAY_TIME);
    this.minStartDate = new Date(currTime - 90 * 24 * 60 * 60 * 1000);
    this.minEndDate = new Date(currTime - 90 * 24 * 60 * 60 * 1000);
    this.endValue = this.currenDate(this.endDate);
  },
  filters: {
    currenDate(date) {
      let year = date.getFullYear();
      let month =
        date.getMonth() + 1 < 10
          ? '0' + (date.getMonth() + 1)
          : date.getMonth() + 1;
      let day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
      return year + '-' + month + '-' + day;
    },
    //判断数据是否超过一万
    transWan(value) {
      if (value < 10000) return value;
      else {
        return (value / 10000).toFixed(1) + '万';
      }
    },
    regroupMapStatus(val) {
      let status = ' ';
      if (val === 4 || val === 14) {
        status = '封禁';
      } else if (val === 10 || val === 13 || val === 17) {
        status = '审核成功';
      } else if (val === 2 || val === 3 || val === 7 || val === 8) {
        status = '隐藏';
      } else {
        status = '审核中';
      }
      return status;
    },
    _regroupMapType(val) {
      return regroupMapType(val);
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.getIncomeData();
    },
    onRefresh() {
      this.finished = false;
      this.loading = true;
      this.onLoad();
    },
    onLoad() {
      this.pageInfo.page = this.pageInfo.page + 1;
      this.getIncomeData();
    },
    updateStartDate() {
      this.pageInfo.page = 1;
      this.tableData = []; //清空数组
      this.getIncomeData();
      this.showStart = false;
    },
    updateEndDate() {
      this.pageInfo.page = 1;
      this.tableData = []; //清空数组
      this.getIncomeData();
      this.showEnd = false;
    },
    //选择时间范围
    changeDate(index) {
      if (index === 1) {
        this.showStart = true;
      } else {
        this.showEnd = true;
      }
    },
    changeSort(item) {
      this.pageInfo.sortType = item.value;
      this.range = 4;
      this.pageInfo.page = 1;
      this.tableData = [];
      this.getIncomeData();
    },
    //切换日期范围
    changeDay(item) {
      this.pageInfo.page = 1;
      this.tableData = [];
      this.dayValue = item.value;
      let startTime = '';
      let endTime = '';
      const nowTime = new Date(new Date().toDateString()).getTime();
      //判断选择时间是7天/30天/90天
      endTime = nowTime - 1;
      if (this.dayValue == 7) {
        startTime = nowTime - 7 * ONE_DAY_TIME;
        this.range = 2;
      } else if (this.dayValue == 30) {
        startTime = nowTime - 30 * ONE_DAY_TIME;
        this.range = 3;
      } else {
        startTime = nowTime - 90 * ONE_DAY_TIME;
        this.range = 4;
      }
      this.startDate = new Date(startTime);
      this.endDate = new Date(endTime);
      this.getIncomeData();
      // this.getMotivateData();
      // this.getMapList();
    },
    currenDate(date) {
      let year = date.getFullYear();
      let month =
        date.getMonth() + 1 < 10
          ? '0' + (date.getMonth() + 1)
          : date.getMonth() + 1;
      let day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
      return year + '' + month + '' + day;
    },
    routeDate(time) {
      let date = new Date(time * 1000);
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let day = date.getDate();
      //console.log(time);
      month = month < 10 ? '0' + month : month;
      day = day < 10 ? '0' + day : day;
      return year + '-' + month + '-' + day;
    },
    async getIncomeData() {
      let start_time = parseInt(this.startDate.getTime() / 1000, 10);
      let end_time = parseInt(this.endDate.getTime() / 1000, 10);
      let data = {
        sort_type: this.pageInfo.sortType,
        page: this.pageInfo.page,
        page_size: this.pageInfo.pageSize,
        start_time: start_time,
        income_type: '1',
        end_time: end_time,
      };
      try {
        const res = await getIncomeWorkList(data);
        if (res.data.list) {
          let list = res.data.list.map(item => {
            item.contribution = Number(item.contribution).toFixed(3);
            item.minibean = item.minibean | 0;
            item.minipoint = item.minipoint | 0;
            item.contribution = item.contribution | 0;
            item.ad_other = item.ad_other | 0;
            item.ad_shop = item.ad_shop | 0;
            item.ad_trigger = item.ad_trigger | 0;
            item.ad_passcheck = item.ad_passcheck | 0;
            item.ad_income = item.ad_income | 0;
            item.other = item.other | 0;
            item.upload_time = this.routeDate(item.upload_time);
            return item;
          });
          this.tableData = this.tableData.concat(list);
          this.refreshing = false;
          this.loading = false;
          this.pageInfo.total = res.data.total_count;
          if (this.tableData.length >= this.pageInfo.total)
            this.finished = true; //表示加载完成
        }
      } catch (err) {
        console.log(err);
      }
    },
    // 跳转 地图详情
    navToDetail({ id }) {
      this.$router.push({ path: '/charts/map-detail', query: { id } });
    },
    sumNumber(item) {
      return (item.xq4_time || 0) + (item.xq4_shop || 0) + (item.xq3 || 0);
    },
  },
};
</script>
<style lang="scss" scoped>
.list-wrap {
  margin-top: -10px;
  padding: 0 4px;
  .data-wrap {
    margin-top: 29px;
    .item {
      background: #ffffff;
      //   height: 340px;
      border-radius: 8px;
      margin-bottom: 20px;
      .top {
        display: flex;
        margin-left: 20px;
        margin-right: 20px;
        padding-top: 20px;
        padding-bottom: 25px;
        border-bottom: 1px solid #d8d8d8;
        .img-wrap {
          width: 267px;
          height: 150px;
          margin-right: 16px;
          position: relative;
          .map-img {
            width: 267px;
            height: 150px;
          }
          .corner {
            width: 70px;
            position: absolute;
            top: 0;
            right: 0;
          }
        }
        .right {
          .title {
            width: 364px;
            height: 80px;
            color: #000000;
            font-size: 28px;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            text-overflow: ellipsis;
            display: -webkit-box;
            overflow: hidden;
          }
          .label {
            display: flex;
            font-size: 22px;
            color: #ffffff;
            margin-top: 8px;
            margin-bottom: 11px;
            .label1 {
              height: 30px;
              padding: 0px 21px;
              background: #0e96ff;
              border-radius: 4px;
              margin-right: 10px;
              display: flex;
              align-items: center;
            }
            .label2 {
              padding: 0px 19px;
              height: 30px;
              border-radius: 4px;
              background: #fea210ff;
              display: flex;
              align-items: center;
            }
            .label2.success {
              background: #2fce43ff;
            }
            .label2.fail {
              background: #ff5c5cff;
            }
          }
          .time {
            font-size: 22px;
            color: #8c8c8c;
          }
        }
      }
      .bottom {
        padding-top: 18px;
        padding-left: 20px;
        font-size: 24px;
        color: #8c8c8c;
        .top-box {
          display: flex;
          margin-bottom: 18px;
          .value {
            width: 200px;
          }
          .value-custom {
            width: 200px;
            margin-left: 15px;
            margin-right: 15px;
          }
        }
        .bottom-box {
          display: flex;
          padding-bottom: 20px;
          .value {
            width: 200px;
          }
          /deep/ .value-custom {
            width: 200px;
            margin-left: 15px;
            margin-right: 15px;
            // .van-hairline--top-bottom::after {
            //   border: none;
            // }
            .van-cell {
              padding: 0px;
              justify-content: flex-start;
              .van-cell__title {
                font-size: 0.16rem;
                color: #8c8c8c;
                line-height: 1.5;
                flex: none;
              }
              .van-cell__right-icon {
                margin-left: 0.1rem;
                line-height: 1;
                @media screen and (min-width: 700px) {
                  line-height: 2;
                }
                @media screen and (min-width: 1000px) {
                  line-height: 3;
                }
              }
            }
            .van-collapse-item__content > p {
              font-size: 0.12rem;
            }
          }
          .value-custom-w {
            width: 400px;
          }
        }
      }
    }
    .complete-tip {
      font-size: 24px;
      color: #8c8c8c;
      text-align: center;
    }
  }
  .pagenation {
    margin-top: 63px;
  }
}
</style>
<style
  src="../../../../assets/styles/filterPanel.less"
  lang="less"
  scoped
></style>
